import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../constants/config";
import { Building2, Globe } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";

function SuperSchooladminSchools() {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchSchoolStats();
  }, []);

  const fetchSchoolStats = async () => {
    try {
      setError("");
      const response = await axiosInstance.get(API_ENDPOINTS.schoolsStats);
      setSchools(response.data?.data?.schools ?? []);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load schools");
      setSchools([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-muted-foreground">Loading schools...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">My Schools</h2>
        <p className="text-sm text-muted-foreground mt-1">
          View all schools in your group (read-only).
        </p>
      </div>

      {error && (
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          {error}
        </div>
      )}

      {schools.length === 0 && !error ? (
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <Building2 className="h-16 w-16 text-gray-300 mb-4" />
            <p className="text-muted-foreground">No schools in your group yet.</p>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>School Name</TableHead>
                <TableHead>Domain</TableHead>
                <TableHead>Group</TableHead>
                <TableHead className="text-right">Users</TableHead>
                <TableHead className="text-right">Students</TableHead>
                <TableHead className="text-right">Teachers</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {schools.map((school) => (
                <TableRow key={school._id}>
                  <TableCell className="font-medium">
                    <div className="flex items-center gap-2">
                      <Building2 className="h-4 w-4 text-muted-foreground" />
                      {school.name}
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <Globe className="h-4 w-4 text-muted-foreground" />
                      {school.domain}
                    </div>
                  </TableCell>
                  <TableCell>{school.group || "—"}</TableCell>
                  <TableCell className="text-right">
                    {school.stats?.totalUsers ?? school.userCount ?? 0}
                  </TableCell>
                  <TableCell className="text-right">
                    {school.stats?.totalStudents ?? "—"}
                  </TableCell>
                  <TableCell className="text-right">
                    {school.stats?.totalTeachers ?? "—"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}

export default SuperSchooladminSchools;
